<template>
  <div class="seg-content seg-sbs">
    <div v-if="tab=='payment'" class="user-form">(loading your payment)</div>
    <div class="user-form payment-list" v-if="tab=='payment3'">
      <h2>Your order</h2>
      <cart-view />
      <address>
Kathryn Ross-Nash New York Pilates , LLC<br />
7004 207th St E<br />
Bradenton Fl, 34211, USA
      </address>
    </div>
    <form class="user-form login payment-form" v-if="tab=='payment3'" ref="payment3Form" v-on:submit.prevent="doSubmitPayment">
      <div class="uf-row">
        <label>Cardholder Name:</label>
        <input type="text" v-model="cardName" required>
      </div>
      <div class="uf-row">
        <label>Address:</label>
        <input type="text" v-model="userProfile.address" required>
      </div>
      <div class="uf-row">
        <label>City:</label>
        <input type="text" v-model="userProfile.city" required>
      </div>
      <div class="uf-row">
        <label>Zip/Postal Code:</label>
        <input type="text" v-model="userProfile.zipcode" required>
      </div>
      <div class="uf-row">
        <label>State:</label>
        <select type="text" v-if="states[userProfile.country]" v-model="userProfile.state" required>
          <option v-for="state in states[userProfile.country]">{{ state }}</option>
        </select>
        <input v-else type="text" v-model="userProfile.state" required>
      </div>
      <div class="uf-row">
        <label>Country:</label>
        <select type="text" v-model="userProfile.country" required>
          <option v-for="country in countries">{{ country }}</option>
        </select>
      </div>
      <template v-if="advPay && payMode==null">
        <div class="uf-row">
          <label>Choose your payment method:</label>
        </div>
        <div class="uf-row pay-method">
          <button v-on:click.prevent="selectMode('stripe')">Credit Card</button>
          <button v-on:click.prevent="selectMode('paypal')">PayPal</button>
        </div>
      </template>
      <template v-else-if="advPay && payMode=='paypal' && paymentReady">
        <div class="uf-row to-c">
          <button class="main" v-on:click.prevent="openPaymentUrl">Pay with PayPal</button>
        </div>
      </template>
      <template v-else-if="advPay && payMode=='paypal'">
        <div class="uf-row">
          Preparing payment...
        </div>
      </template>
      <template v-else-if="!advPay || payMode=='stripe'">
        <div class="uf-row">
          <label>Card Number:</label>
          <div class="card" ref="payment3"></div>
        </div>
        <div class="uf-row error" v-html="cardErrors">{{ cardErrors }}</div>
        <div class="uf-row to-c">
          <button class="main">Pay now</button>
        </div>
      </template>
    </form>
    <iframe v-if="tab=='payment2'" :src="paymentReady" class="payframe" style="height: 900px; width: 100%"></iframe>
  </div>
</template>
<script>
import api from './api';
import moment from 'moment';
import mainNav from './mainNav';
import Cookies from 'js-cookie';
export default {
  mixins: [mainNav],
  data: ()=>({
    advPay: appData.advPay,
    payMode: null,
    tab: 'payment3',
    paymentReady: null,
    paymentSecret: null,
    success: false,
    cardErrors: null,
    cardName: "",
    userProfile: {},
    groups: [],
    individualGroups: [],
    paymentSecret: null,
//     buyGroup: {},
//     buyVideo: {},
//     cartItems: [],
    countries: [
      "United States",
      "Canada",
      "Afghanistan",
      "Albania",
      "Algeria",
      "American Samoa",
      "Andorra",
      "Angola",
      "Anguilla",
      "Antarctica",
      "Antigua and Barbuda",
      "Argentina",
      "Armenia",
      "Aruba",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bermuda",
      "Bhutan",
      "Bolivia",
      "Bosnia and Herzegovina",
      "Botswana",
      "Bouvet Island",
      "Brazil",
      "British Indian Ocean Territory",
      "Brunei",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cambodia",
      "Cameroon",
      "Cape Verde",
      "Cayman Islands",
      "Central African Republic",
      "Chad",
      "Chile",
      "China",
      "Christmas Island",
      "Cocos (Keeling) Islands",
      "Colombia",
      "Comoros",
      "Congo",
      "Cook Islands",
      "Costa Rica",
      "Croatia",
      "Cuba",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic",
      "East Timor",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Eritrea",
      "Estonia",
      "Ethiopia",
      "Falkland Islands",
      "Faroe Islands",
      "Fiji Islands",
      "Finland",
      "France",
      "French Guiana",
      "French Polynesia",
      "French Southern territories",
      "Gabon",
      "Gambia",
      "Georgia",
      "Germany",
      "Ghana",
      "Gibraltar",
      "Greece",
      "Greenland",
      "Grenada",
      "Guadeloupe",
      "Guam",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guinea-Bissau",
      "Guyana",
      "Haiti",
      "Heard Island and McDonald Islands",
      "Holy See (Vatican City State)",
      "Honduras",
      "Hong Kong",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland",
      "Isle of Man",
      "Israel",
      "Italy",
      "Ivory Coast",
      "Jamaica",
      "Japan",
      "Jersey",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kiribati",
      "Kuwait",
      "Kyrgyzstan",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libyan Arab Jamahiriya",
      "Liechtenstein",
      "Lithuania",
      "Luxembourg",
      "Macao",
      "North Macedonia",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Marshall Islands",
      "Martinique",
      "Mauritania",
      "Mauritius",
      "Mayotte",
      "Mexico",
      "Micronesia, Federated States of",
      "Moldova",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Montserrat",
      "Morocco",
      "Mozambique",
      "Myanmar",
      "Namibia",
      "Nauru",
      "Nepal",
      "Netherlands",
      "Netherlands Antilles",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "Niue",
      "Norfolk Island",
      "North Korea",
      "Northern Ireland",
      "Northern Mariana Islands",
      "Norway",
      "Oman",
      "Pakistan",
      "Palau",
      "Palestine",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Pitcairn",
      "Poland",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Reunion",
      "Romania",
      "Russian Federation",
      "Rwanda",
      "Saint Helena",
      "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Pierre and Miquelon",
      "Saint Vincent and the Grenadines",
      "Samoa",
      "San Marino",
      "Sao Tome and Principe",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "Solomon Islands",
      "Somalia",
      "South Africa",
      "South Georgia and the South Sandwich Islands",
      "South Korea",
      "South Sudan",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Suriname",
      "Svalbard and Jan Mayen",
      "Swaziland",
      "Sweden",
      "Switzerland",
      "Syria",
      "Tajikistan",
      "Tanzania",
      "Thailand",
      "The Democratic Republic of Congo",
      "Timor-Leste",
      "Togo",
      "Tokelau",
      "Tonga",
      "Trinidad and Tobago",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Turks and Caicos Islands",
      "Tuvalu",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United Kingdom",
      "United States Minor Outlying Islands",
      "Uruguay",
      "Uzbekistan",
      "Vanuatu",
      "Venezuela",
      "Vietnam",
      "Virgin Islands, British",
      "Virgin Islands, U.S.",
      "Wallis and Futuna",
      "Western Sahara",
      "Yemen",
      "Zambia",
      "Zimbabwe",
    ],
    states: {
      "United States": [
        "Alabama",
        "Alaska",
        "American Samoa",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "District Of Columbia",
        "Federated States Of Micronesia",
        "Florida",
        "Georgia",
        "Guam",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Marshall Islands",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Northern Mariana Islands",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Puerto Rico",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virgin Islands",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming",
      ],
      "Canada": [
        "Alberta",
        "British Columbia",
        "Manitoba",
        "New Brunswick",
        "Newfoundland",
        "Northwest Territories",
        "Nova Scotia",
        "Nunavut",
        "Ontario",
        "Prince Edward Island",
        "Quebec",
        "Saskatchewan",
        "Yukon Territories",
      ],
    },
  }),
  computed: {
    totalPrice() {
      return this.cartItems.map((a)=>a.price).reduce((a,b)=>a*1+b*1, 0);
    },
  },
  watch: {
    tab: {
      handler() {
        this.menuItems.forEach((el)=>el.active=el.args && el.args.tab==this.tab);
        this.success=false;
      }, immediate: true,
    },
  },
  methods: {
    async savePayment() {
      if (!window.appRoot.loggedIn)
        return;
      var result=await api.request("POST", "/pay", {});
      if (result.free) {
        await this.loadUserData();
        appNotifications.show("You are now subscribed", "success");
        this.$router.go(-1);
        return;
      }
      if (result.url) {
        location.href=result.url;
        this.paymentReady=result.url;
        this.tab="payment2";
      } else if(result.client_secret) {
        this.paymentSecret=result.client_secret;
        this.tab="payment3";
        this.stripeEls = this.stripe.elements();
        var style = {
          base: {
            color: "black",
            
          }
        };
        var card = this.stripeCard = this.stripeEls.create("card", { style: style });
        this.$nextTick(()=>{
          card.mount(this.$refs.payment3);
        });
        card.on('change', ({error}) => {
          this.cardErrors=error?error.message:null;
        });
        
      } else {
        alert("Preparing payment failed, please try again.");
        this.$router.go(-1);
      }
    },
    async doSubmitPayment() {
      await api.update("User", appRoot.loggedIn.id, {
        address: this.userProfile.address,
        city: this.userProfile.city,
        zipcode: this.userProfile.zipcode,
        state: this.userProfile.state,
        country: this.userProfile.country,
      });
      var result=await this.stripe.confirmCardPayment(this.paymentSecret, {
        payment_method: {
          card: this.stripeCard,
          billing_details: {
            name: this.cardName,
          }
        }
      })
      if (result.error) {
        this.cardErrors=result.error.message;
      } else {
        if (result.paymentIntent.status === 'succeeded') {
          setTimeout(()=>{
            location.replace("/pay/success/x");
          }, 1000);
        }
        console.log(result.paymentIntent);
      }
    },
    async savePaymentPaypal() {
      if (!window.appRoot.loggedIn)
        return;
      var result=await api.request("POST", "/pay/paypal", {});
      if (result.free) {
        await this.loadUserData();
        appNotifications.show("You are now subscribed", "success");
        this.$router.go(-1);
        return;
      }
      if (result.url) {
//         location.href=result.url;
        this.paymentReady=result.url;
//         this.tab="payment2";
      } else {
        alert("Preparing payment failed, please try again.");
        this.$router.go(-1);
      }
    },
    async loadUser() {
      if (appRoot.loggedIn) {
        this.userProfile=(await api.get("User", appRoot.loggedIn.id)).item;
        if (!this.userProfile.country)
          this.userProfile.country="United States";
        this.cardName=this.userProfile.firstname+" "+this.userProfile.lastname;
      }
    },
    selectMode(mode) {
      this.payMode=mode;
      if (mode=="stripe")
        this.savePayment();
      else if (mode=="paypal")
        this.savePaymentPaypal();
    },
    openPaymentUrl() {
      location.href=this.paymentReady;
    },
  },
  created() {
    if (!window.appRoot.loggedIn) {
      this.$router.replace({name: 'user.register'});
    } else {
      this.stripe = Stripe(appData.stripePk);
    }
  },
  mounted() {
    this.loadUser();
    if (!appData.advPay) {
      this.savePayment();
    }
  },
}
</script>
